import { render, staticRenderFns } from "./CometencyParent.vue?vue&type=template&id=972e25b8"
import script from "./CometencyParent.vue?vue&type=script&lang=js"
export * from "./CometencyParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports